import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {Observable} from "rxjs/internal/Observable";

@Component({
    selector: 'db-refund-items',
    templateUrl: './refund-items.component.html',
    styleUrls: ['./refund-items.component.scss'],
    standalone: false
})
export class RefundItemsComponent implements OnInit {
  @Input() quantity: number;
  @Input() fullRefund: boolean;
  @Input() resetQuantity: boolean[] = [];
  @Input() reset: Observable<boolean>;
  @Output() quantityChange = new EventEmitter<number>();

  refundQuantity: FormControl;

  ngOnInit() {
    this.refundQuantity = new FormControl(!!this.fullRefund ? this.quantity : 0, [
      Validators.required,
      Validators.pattern(/^[0-9]+$/)
    ]);


    this.refundQuantity.valueChanges.subscribe(value => {
      this.handleValueChange(value);
    });

    this.reset.subscribe(reset => {
      if (reset) {
        this.refundQuantity.setValue(0);  // Reset the quantity to 0
      }
    });
  }

  handleValueChange(value: any) {
    // Emit changes if the value is valid
    if (this.refundQuantity.valid) {
      this.quantityChange.emit(value);
    }
  }

  increment() {
    if (this.refundQuantity.value < this.quantity) {
      this.refundQuantity.setValue(this.refundQuantity.value + 1);
    }
  }

  decrement() {
    if (this.refundQuantity.value > 0) {
      this.refundQuantity.setValue(this.refundQuantity.value - 1);
    }
  }



}
